import {
  AccordionItemContext
} from "./chunk-YQFL5UN4.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/accordion/accordion-content.tsx
import { forwardRef, useContext } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var AccordionContent = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
    const context = useContext(AccordionItemContext);
    if (context === null) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      "div",
      __spreadProps(__spreadValues(__spreadProps(__spreadValues({
        id: context.contentId,
        "data-state": context.open ? "open" : "closed"
      }, { inert: context.open ? void 0 : "true" }), {
        className: clsx("hds-accordion-item-content", className),
        ref
      }), rest), {
        children: /* @__PURE__ */ jsx("div", { className: clsx("hds-accordion-item-content-inner"), children })
      })
    );
  }
);
AccordionContent.displayName = "Accordion.Content";

export {
  AccordionContent
};
//# sourceMappingURL=chunk-5FWY7FIX.mjs.map